module.exports = __webpack_public_path__ + "static/media/sales-order-slide-8.48367a1b.jpg";